// @ts-nocheck
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router'
import { gql } from '@apollo/client'
import { useMutation, useQuery } from '@apollo/client/react'

import Button from 'js/components/Button'
import FetchMore from 'js/components/FetchMore'
import { H4 } from 'js/components/Heading'
import LoadingSpinner from 'js/components/LoadingSpinner/LoadingSpinner'
import { NOTIFICATIONS_UNREAD_QUERY } from 'js/components/NavigationNotifications/NavigationNotifications'
import Text from 'js/components/Text/Text'
import NavigationMenu from 'js/layout/Navigation/components/NavigationMenu'
import Notification from 'js/user/Notifications/components/Notification'
import { NOTIFICATIONS_QUERY } from 'js/user/Notifications/Notifications'

const NavigationNotificationsView = ({
    viewer,
    visible,
    hasUnread,
    hideNotifications,
}) => {
    const { t } = useTranslation()

    const [markAllAsRead] = useMutation<any>(MARK_ALL_AS_READ)

    const handleMarkAllAsRead = () => {
        markAllAsRead({
            variables: {
                input: {},
            },
            refetchQueries: [NOTIFICATIONS_QUERY, NOTIFICATIONS_UNREAD_QUERY],
        })
    }

    const PAGE_SIZE = 10
    const { loading, data, fetchMore, refetch } = useQuery<any>(
        NOTIFICATIONS_QUERY,
        {
            skip: !visible,
            variables: {
                offset: 0,
                limit: PAGE_SIZE,
                unread: true,
            },
        },
    )

    useEffect(() => {
        // TODO: We manually refetch the query because fetchPolicy: 'cache-and-network' causes the scrollbar to reset on fetchMore
        if (visible === true) {
            refetch()
        }
    }, [visible, refetch])

    return (
        <NavigationMenu>
            <div className="NavigationMenuHeader">
                <H4
                    style={{
                        marginTop: '4px',
                        marginRight: '4px',
                    }}
                >
                    {t('notifications.unread-notifications')}
                </H4>
                {hasUnread && (
                    <Button
                        size="small"
                        variant="tertiary"
                        onClick={handleMarkAllAsRead}
                    >
                        {t('notifications.read-all')}
                    </Button>
                )}
            </div>

            {!data || loading ? (
                <LoadingSpinner
                    style={{ marginTop: '-8px', marginBottom: '16px' }}
                />
            ) : (
                <FetchMore
                    isScrollableBox
                    edges={data.notifications.edges}
                    getMoreResults={(data) => data.notifications.edges}
                    fetchMore={fetchMore}
                    fetchType="scroll"
                    fetchCount={10}
                    maxLimit={data.notifications.total}
                    noResults={
                        <Text
                            size="small"
                            variant="grey"
                            className="NavigationMenuEmpty"
                            role="alert"
                        >
                            {t('notifications.no-notifications')}
                        </Text>
                    }
                    className="NavigationMenuList"
                >
                    <ul>
                        {data.notifications.edges.map((notification, i) => (
                            <Notification
                                key={i}
                                notification={notification}
                                hideNotifications={hideNotifications}
                            />
                        ))}
                    </ul>
                </FetchMore>
            )}

            <NavLink
                to={`/user/${viewer.user.username}/notifications`}
                onClick={hideNotifications}
                className="NavigationMenuFooter"
            >
                {t('notifications.all-notifications')}
            </NavLink>
        </NavigationMenu>
    )
}

const MARK_ALL_AS_READ = gql`
    mutation NotificationsTop($input: markAllAsReadInput!) {
        markAllAsRead(input: $input) {
            success
        }
    }
`

export default NavigationNotificationsView
